import * as Icons from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { WHY_US } from "../data/site";

export const WhyUs = () => (
  <section id="why-us" data-testid="why-us-section" className="bg-[#0A0A0A] px-6 py-24 md:px-12 md:py-32">
    <div className="mx-auto max-w-7xl">
      <SectionHead
        id="why-us"
        overline="Chapter 07 — The Difference"
        title="Why Choose Renuka Roofing Structurals?"
      />

      <div className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
        {WHY_US.map((w, i) => {
          const Icon = Icons[w.icon];
          return (
            <Reveal key={w.title} delay={(i % 3) * 0.08} className="bg-[#0A0A0A]">
              <div
                data-testid={`why-us-item-${i + 1}`}
                className="group h-full bg-[#0A0A0A] p-10 transition-colors duration-500 hover:bg-[#0D1420]"
              >
                <div className="flex items-center justify-between">
                  <Icon size={28} strokeWidth={1.5} className="text-[#0055FF] transition-transform duration-500 group-hover:-translate-y-1" />
                  <span className="font-display text-3xl font-extrabold text-outline">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-8 font-display text-xl font-semibold tracking-tight">{w.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#A3A3A3]">{w.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
